







import { Component, Vue, Ref } from 'vue-property-decorator';

import ListaList from './ListaList.vue';

@Component({
	components: {
		ListaList,
	},
})
export default class Liste extends Vue {
	@Ref('list') list!: ListaList;

	constructor() {
		super();
	}
}
